import { jsx as _jsx } from "react/jsx-runtime";
import * as Utils from '_utils';
import * as React from 'react';
const themeStorageKey = 'theme';
export const ThemeDefault = 'standard';
export const ThemeLcars = 'lcars';
export const ThemeDark = 'dark';
export const ThemeLight = 'light';
export const ThemeContext = React.createContext({
    ...getDefaultTheme(),
    setTheme: () => { },
});
ThemeContext.displayName = 'ThemeContext';
export function ThemeProvider(props) {
    const [state, setState] = React.useState(getDefaultTheme());
    function callback(theme) {
        setState(theme);
        const body = document.body;
        body.setAttribute('data-theme', theme.name);
        body.setAttribute('data-theme-variant', theme.variant);
        Utils.setLocalData(themeStorageKey, theme);
    }
    React.useEffect(() => {
        callback(getTheme());
    }, []);
    return (_jsx(ThemeContext.Provider, { value: { ...state, setTheme: callback }, children: props.children }));
}
export function useTheme() {
    return React.useContext(ThemeContext);
}
export function getTheme() {
    // TODO stroe the theme into the local storage
    return {
        name: ThemeLcars,
        variant: ThemeDark,
    };
}
export function getDefaultTheme() {
    return {
        name: ThemeLcars,
        variant: ThemeDark,
    };
}
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */ // will be used in the future
function getPreferredColorScheme() {
    if (window.matchMedia) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        else {
            return 'light';
        }
    }
    return 'light';
}
